import { v4 as uuidv4, v4 } from "uuid";

interface IDefaultNotificationCreator {
    title: string,
    description: string,
    createdAt?: number,
    type?: string,
    iconType?: string,
    id?: string
}

export const defaultNotificationCreator = (
    {
        title,
        description,
        createdAt = Date.now(),
        type = "default",
        iconType = "default",
        id = v4()
    }: IDefaultNotificationCreator
): IDefaultNotificationCreator => ({
    title: title,
    description: description,
    createdAt: createdAt,
    type: type,
    iconType: iconType,
    id: id
})